import React from "react";
import Lottie from "react-lottie";
import "./Scroll_to_top.css";
import * as animationData from "./Scroll_to_top.json";

function Scroll_to_top({onClick, ...props}) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main" onClick={onClick}>
      <div className="Scroll_to_top">
        <div className="Scroll_to_top_Lottie_icon">
          <Lottie className="me-auto" options={defaultOptions} />
        </div>
      </div>
    </section>
  );
}
export default Scroll_to_top;
